import axios from './instance'
import { getErrorMessage } from '../utils/helpers'

/**
 * Get an exhibitor's purchase history, which each receipt is rendered from.
 *
 * The API only lists transactions that actually bought something, so refund records and
 * declined attempts never show up here.
 * @param {string} url
 * @param {func} setError
 * @param {func} setLoading
 * @returns `data` results
 */
export const getTransactions = async (url, setError = () => {}, setLoading = () => {}) => {
  setLoading(true)

  try {
    const data = await axios.get(url)

    setLoading(false)
    return data
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Charge a card for a purchase.
 * @param {string} eventId
 * @param {string} eventExhibitorId
 * @param {object} transactionData
 * @param {func} setError
 * @param {func} setLoading
 * @param {func} setSuccess
 * @param {func} onDuplicate called with the API's explanation when this purchase looks
 *  like a repeat of one just made, instead of `setError`. Resubmit with
 *  `confirm_duplicate: true` to go ahead. Falls back to an error when not supplied.
 */
export const createTransaction = async (
  eventId,
  eventExhibitorId,
  transactionData,
  setError = () => {},
  setLoading = () => {},
  setSuccess = () => {},
  onDuplicate = null,
) => {
  setLoading(true)

  try {
    const data = await axios.post(
      `/events/${eventId}/exhibitors/${eventExhibitorId}/transactions/`,
      transactionData,
    )
    setLoading(false)
    setSuccess(true)
    return data
  } catch (err) {
    setLoading(false)

    // A purchase that repeats one made moments ago comes back as a question rather than
    // a failure (EXEC-1605) — the buyer is the only one who knows whether it's a real
    // second order. With nobody to ask it falls through to the usual error.
    const repeatWarning = err?.response?.data?.duplicatePurchase?.[0]
    if (repeatWarning && onDuplicate) {
      onDuplicate(repeatWarning)
      return null
    }

    setError(getErrorMessage(err))
    return null
  }
}
